module.exports = __webpack_public_path__ + "static/media/Fresh_Green_Lens.a8f46943.png";